<template lang="html">
  <div class="dashboard">
    <v-header :name="name"></v-header>
    <div class="container">
      <div class="left">
        <div class="item">
          <v-bars></v-bars>
        </div>
        <div class="item">
          <v-two-way-bar></v-two-way-bar>
        </div>
        <div class="item">
          <v-table></v-table>
        </div>
      </div>
      <div class="center">
        <v-center></v-center>
      </div>
      <div class="right">
        <div class="item">
          <v-bar></v-bar>
        </div>
        <div class="item">
          <v-pie></v-pie>
        </div>
        <div class="item">
          <v-analyse></v-analyse>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bars from 'components/helpPoor/bar'
import twoWayBar from 'components/helpPoor/twoWayBar'
import header from 'components/common/header'
import pie from 'components/helpPoor/pie'
import table from 'components/helpPoor/table'
import bar from 'components/helpPoor/bars'
import center from 'components/helpPoor/center'
import analyse from 'components/helpPoor/analyse'

export default {
  data() {
    return {
      items: [],
      name: '田阳县农业大脑——扶贫数据中心'
    }
  },
  mounted() {
  },
  methods: {
  },
  components: {
    'v-bars': bars,
    'v-header': header,
    'v-table': table,
    'v-pie': pie,
    'v-bar': bar,
    'v-center': center,
    'v-two-way-bar': twoWayBar,
    'v-analyse': analyse
  }
}

</script>

<style lang="stylus" scoped>
.item
    margin-bottom 15px
.dashboard
    position relative
    width 100%
    height 100%
    margin 0
    padding 0
    background url('../../../static/img/common/bg.png')
    background-size 100% 100%
.container
    display flex
    height 100%
    padding 0 15px
    .center
      width 896px
      margin 30px auto
    .left, .right
       width 450px
       margin-top -25px
</style>



// WEBPACK FOOTER //
// index.vue?609bc05d